<template>
  <div class="grid-x grid-margin-x grid-padding-x align-center">
    <div class="medium-12 cell">
      <form class="form-horizontal new-lg-form" v-on:submit.prevent="login">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-9 small-12">
                <a href="/api/auth/google" class="abcRioButton abcRioButtonBlue"><div class="abcRioButtonContentWrapper"><div class="abcRioButtonIcon"><div class="abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg></div></div><span class="abcRioButtonContents"><span id="not_signed_injysz01as6q36">{{ $t('label.loginGoogle') }}</span></span></div></a>
            </div>
        </div>

        <div class="or-divider">
          <span>
            {{ $t('label.or') }}
          </span>
        </div>

        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <input type="text" name="username" id="username" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.username')" v-bind:disabled="showAuthcode">
            </div>
        </div>

        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <input ref="input" class="password" name="password" id="password" type="password" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.password')" v-bind:disabled="showAuthcode">

                <span class="unmask material-icons" v-bind:class="showPwd ? 'off' : ''" v-on:click="mask" title="Visualizza/nascondi password"></span>
            </div>
        </div>

        <div class="grid-x grid-padding-x" v-if="showAuthcode">
            <div class="cell small-12">
                <input type="text" name="authcode" id="authcode" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.secure_code')">
            </div>
        </div>

        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <span class="messageError beebeeLabel">{{error}}</span>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6">
                <button class="button button-default expanded hovering ld-over" v-bind:class="running ? 'running' : ''" type="submit">
                  {{ $t('label.login') }}
                  <div class="ld ld-ball ld-flip"></div>
                </button>
            </div>
            <div class="cell small-12 medium-6 text-right sideButton">
              <router-link to="recover" class="link-underline">
                {{ $t('label.forgotPassword') }}
              </router-link>
            </div>
        </div>
        
      </form>
    
      <div class="loginOption text-right" v-if="$parent.openRegistration">
         <div class="text-right">
          {{ $t('label.notHaveAccount') }} 
          <router-link to="register" class="link-underline">
            {{ $t('label.signUp') }}
          </router-link>
          <br />
          {{ $t('label.lessThenMinute') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as CONFIG from '../config'

export default {
  name: 'login',
  data: () => ({
    error: '',
    showPwd: false,
    running: false,
    showAuthcode: false
  }),
  props: {
    redirect: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'password'
    }
  },

  mounted () {
    this.$refs.input.type = this.type
  },

  created () {
    var accessToken = this.$cookie.get('secure')
    var self = this

    if (accessToken) {
      console.log('TOKEN PRESENTE')
      axios.get(`${CONFIG.BASEURL}/api/v1/contacts/me`, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then(res => {
        if (res && res.data && res.data.data && res.data.data.relationships && res.data.data.relationships.role && res.data.data.relationships.role.data && res.data.data.relationships.role.data.id) {
          var roleId = res.data.data.relationships.role.data.id
          var redirect = 'start'

          for (let i = 0; i < res.data.included.length; i++) {
            if (res.data.included[i].type === 'roles' && res.data.included[i].id === roleId && res.data.included[i].attributes.redirect_page) {
              redirect = res.data.included[i].attributes.redirect_page
            }
          }

          if (redirect.substring(0, 4) === 'http') {
            window.location = redirect + accessToken
          } else {
            if (this.$route.query.r) {
              window.location = this.$route.query.r
            } else {
              window.location = `${CONFIG.BASEURL}/${redirect}`
            }
          }
        } else {
          if (this.$route.query.r) {
            window.location = this.$route.query.r
          } else {
            window.location = `${CONFIG.BASEURL}/start`
          }
        }
      })
    }

    axios.get(`${CONFIG.BASEURL}/api/v1/organizations/open`)
    .then(response => {
      if (!response.data.data.attributes.active) {
        self.$router.push('no_active')
      }
    })
  },

  methods: {
    login () {
      var self = this
      var username = document.getElementById('username').value
      var password = document.getElementById('password').value
      var authcode = this.showAuthcode ? document.getElementById('authcode').value : null

      if (this.running) {
        return false
      }

      if (!username || !password) {
        this.error = 'Empty field'
        return false
      }

      this.error = ''
      this.running = true

      var queryParams = `grant_type=password&username=${username}&password=${password}`
      if (authcode) {
        queryParams += `&authcode=${authcode}`
      }

      axios.post(`${CONFIG.BASEURL}/api/oauth/token`, queryParams, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic YWJjMTIzOnNzaC1zZWNyZXQ='
        },
        cache: false
      })
        .then(response => {
          self.running = false
          console.log(response)

          if (response && response.data && response.data.access_token) {
            response = response.data

            self.$cookie.set('secure', response.access_token, {
              expires: `${(parseFloat(response.expires_in) / 3600)}h`
            })

            if (self.redirect) {
              window.location = self.redirect
              return true
            }

            if (response.redirect) {
              if (response.redirect.substring(0, 4) === 'http') {
                window.location = response.redirect + response.access_token
              } else {
                window.location = `${CONFIG.BASEURL}/${response.redirect}`
              }
            } else {
              window.location = `${CONFIG.BASEURL}/start/`
            }

            return true
          } else if (response && response.data && response.data.authcode && response.data.authcode === 'required') {
            self.showAuthcode = true
          } else {
            self.error = 'Login Error'
            password = ''
          }
        })
        .catch(function () {
          self.running = false
          self.error = 'Login error'
          password = ''
        })
    },
    mask () {
      this.$refs.input.type = (this.$refs.input.type === 'text') ? 'password' : 'text'
      this.showPwd = !this.showPwd
    }
  }
}
</script>

<style scoped>

.loginOption {
  padding-top: 1.5rem;
  line-height: 1.3rem;
  height: 4rem;
  min-height: 4rem;
}

</style>


// WEBPACK FOOTER //
// src/components/Login.vue